export default __webpack_public_path__ + "static/media/Calfrest_angle.b5b60648.svg";